module.exports = __webpack_public_path__ + "img/header-engagementRingsHalo@2x.6e9610e.webp";